import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  breakpoints: {
    base: "0em",
    xs: "20em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em",
    "3xl": "120em",
    "4xl": "160em",
  },
  fonts: { heading: "Montserrat !important", body: "Montserrat !important" },

  colors: {},
  components: {
    Button: {
      baseStyle: {
        fontWeight: "normal",
      },
    },

    Popover: {
      baseStyle: {
        popper: {
          maxWidth: "unset",
          width: "100%",
        },
      },
    },
  },
});

export default theme;
